import React, { useEffect, useState, useCallback } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { getDocs } from '../../api/aprvDoc'; // ✅ 결재문서 조회 API
import { formatDate, docStatusMap, headerMap  } from '../../utils/commonUtils';
import PageList from '../../components/List/PageList';


function AprvDocList({onOpenFormModal}) {
  const [docs, setDocs] = useState([]);
  const [total, setTotal] = useState(0);
  const [searchTerm, setSearchTerm] = useState('');
  const navigate = useNavigate();

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const currentPage = parseInt(queryParams.get('page')) || 1;
  const status = queryParams.get('status') || '';


  const docsPerPage = 5;
  const totalPages = Math.ceil(total / docsPerPage);
  const token = sessionStorage.getItem('token');
  const headerText = headerMap[status] || "📋 결재문서 목록";


  // 📑 문서 목록 조회
  const fetchDocs = useCallback(
    async (page, keyword = '' , status = '') => {
      try {
        const { docs: fetchedDocs, total: fetchedTotal } = await getDocs(
          page,
          docsPerPage,
          keyword,
          status, 
          token,
        );

        setDocs(fetchedDocs);
        //console.log(docs);
        setTotal(fetchedTotal);
      } catch (err) {
        console.error('문서 목록 조회 실패:', err);
      }
    },
    [docsPerPage, token]
  );

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const page = parseInt(params.get('page')) || 1;
    const keyword = params.get('search') || '';
    const status = params.get('status') || '';
    setSearchTerm(keyword);
    fetchDocs(page, keyword, status);
  }, [location.search, fetchDocs, status]);


    // 📑 검색 처리
  const handleSearch = (e) => {
    e.preventDefault();
    const keyword = e.target.search.value.trim();
    setSearchTerm(keyword);
    navigate(`/aprvdoc?page=1&search=${keyword}${status ? `&status=${status}` : ''}`);
  };



  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-12">

          {/* 헤더 영역 */}
          <div className="d-flex justify-content-between align-items-center mb-3">
            <h4 className="mb-0">{headerText}</h4>
              <button
                className="btn btn-primary"
                onClick={onOpenFormModal}  
              >
                새 결재문서 작성
              </button>

          </div>

          {/* 검색 폼 */}
          <form className="row g-2 mb-3" onSubmit={handleSearch}>
            <div className="col-md-6">
              <input
                type="text"
                name="search"
                className="form-control"
                placeholder="제목 또는 기안자 검색"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </div>
            <div className="col-auto">
              <button className="btn btn-outline-secondary" type="submit">검색</button>
            </div>
            <div className="col-auto">
              <button
                className="btn btn-outline-danger"
                type="button"
                onClick={() => {
                  setSearchTerm('');
                  if (status) {
                    navigate(`/aprvdoc?page=1&status=${status}`);
                  } else {
                    navigate(`/aprvdoc?page=1`);
                  }
                }}
              >
                초기화
              </button>
            </div>
          </form>

          {/* 결재문서 목록 + 페이지네이션 */}
          <PageList
            columns={[
              { label: '', style: { width: '36px' } },
              { label: '결재양식', style: { width: '20%' } },
              { label: '제목', style: { width: '28%' } },
              { label: '기안자', style: { width: '15%' }, className: 'text-center' },
              { label: '기안일', style: { width: '15%' }, className: 'text-center' },
              { label: '문서 상태', style: { width: '18%' }, className: 'text-center' },
            ]}
            totalPages={totalPages}
            currentPage={currentPage}
            onPageChange={(page) => navigate(`/aprvdoc?page=${page}&search=${searchTerm}${status ? `&status=${status}` : ''}`)}
            emptyMessage="결재문서가 없습니다."
          >
            {docs.map((doc) => (
              <tr
                key={doc.aprv_id}
                style={{ cursor: 'pointer' }}
                onClick={() => navigate(`/aprvdoc/view/${doc.aprv_id}?page=${currentPage}&search=${searchTerm}${status ? `&status=${status}` : ''}`)}
              >
                <td className="text-center">
                  {doc.attach_yn === 'y' && <i className="fas fa-paperclip text-secondary" />}
                </td>
                <td>{doc.form_name}</td>
                <td><h5 className="font-size-14 mb-0">{doc.title}</h5></td>
                <td className="text-center">{doc.user_name}</td>
                <td className="text-center text-muted">{formatDate(doc.req_date)}</td>
                <td className="text-center">{docStatusMap[doc.doc_status] || doc.doc_status}</td>
              </tr>
            ))}
          </PageList>
        </div>
      </div>
    </div>
  );
}

export default AprvDocList;